module.exports = __webpack_public_path__ + "static/media/platinum_wedding_bands_diamonds_result.ed95c07c.jpg";